import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux'
import { unsubscribeUser } from "../../actions/user.js"
import { error as logError } from "../../logger.js";
import { isValidEmail } from '../../dataProvider/user.js';

import emailIconV2 from "../../img/v2/contact/email.png"

import "../../scss/v2/user/unsubscribe.scss"

function UnsubscribeBlock(props) {

    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [alert, setAlert] = useState(null);
    const [pending, setPending] = useState(false);

    const clickHandler = () => {
        if (!email || !isValidEmail(email)) {
            setAlert("error")
            return;
        }

        setPending(true);

        props.dispatch(unsubscribeUser(email))
            .then(result => {
                setPending(false);
                if (result.nbCustomers === 0) {
                    setAlert("error")
                } else if (result.customerUnsuscribed === 0) {
                    setAlert("warning")
                } else {
                    setAlert("success")
                }
            })
            .catch(err => {
                logError(err)
                setAlert("error")
            })
    }

    const renderAlert = () => {
        if (alert === "error") {
            return (
                <div className="alert alert-danger">{t('unsubscribe.cancelCard.error')}</div>
            )
        } else if (alert === "success") {
            return (
                <div className="alert alert-success">{t('unsubscribe.cancelCard.success')}</div>
            )
        } else if (alert === "warning") {
            return (
                <div className="alert alert-warning">{t('unsubscribe.cancelCard.warning')}</div>
            )
        }
        return;
    }

    return (
        <div className={`unsubscribe-small-card unsubscribe-cancel-card${alert ? " bigger-card" : ''}`}>
            <h2 className="unsubscribe-small-card-title">{t('unsubscribe.cancelCard.title')}</h2>
            <p className="unsubscribe-cancel-card-subtitle">{t('unsubscribe.cancelCard.subtitle')}</p>
            <p className="unsubscribe-cancel-card-text">{t('unsubscribe.cancelCard.text')}</p>
            {renderAlert()}
            <div className="unsubscribe-input-group">
                <p className="unsubscribe-input-group-label">{t('unsubscribe.cancelCard.label')}</p>
                <input className="unsubscribe-input-group-input" placeholder={t('unsubscribe.cancelCard.placeholder')} onChange={(event) => { setEmail(event.target.value) }} />
                <div className="unsubscribe-input-group-left-icon">
                        <img className="img img-fluid unsubscribe-input-group-left-icon-svg" src={emailIconV2} alt={emailIconV2} />
                </div>
            </div>
            <button className="button orange-button" disabled={!!pending} onClick={clickHandler}>{t('unsubscribe.cancelCard.button')}</button>
        </div>
    )

}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(UnsubscribeBlock);